// extracted by mini-css-extract-plugin
module.exports = {"annotation":"ExpandableAnnotation__annotation__6z65U","expanded":"ExpandableAnnotation__expanded__Nu8Dz"};